<script lang="ts">
  import { useNavigate } from 'svelte-navigator';
  import { _ } from 'svelte-i18n';
  import { AppState, ToastQueue } from '../../etc/stores';

  import { Container } from '../../services/container';
  import { Auth } from '../../services/auth';
  import { Logger } from '../../services/logger';
  import Analytics from '../../services/analytics';
  import { extractMessageFromError } from '../../services/api';

  export let loggerContext;
  export let triggerConnectCustomer;
  export let onBeforeConnectCustomer = undefined;
  export let onAfterConnectCustomer = undefined;

  const logger = Container.get(Logger).context(loggerContext) as Logger;

  const auth = Container.get(Auth);

  let loading = false;
  let success = false;
  let error = false;
  let guest = $AppState.website.flowGuestSignIn;
  let navigate;
  let timeout;

  if ($AppState.website.popoverOpen) navigate = useNavigate();

  export const handleConnectCustomer = async () => {
    try {
      if (loading || success) return;
      error = false;
      loading = true;
      auth.beforeAuthHook();

      if (onBeforeConnectCustomer) await onBeforeConnectCustomer();

      const next = await auth.handleConnectAccount();

      success = true;
      Analytics.setSessionAnalyticsOnJoin(next.route, guest);

      if (onAfterConnectCustomer) {
        const response = await onAfterConnectCustomer(next);

        if (response && response.skipNavigate) return;
      }

      if (navigate) {
        navigate(next.route, next.navigationOptions);
      } else {
        AppState.update(state => ({
          ...state,
          website: {
            ...state.website,
            category: '',
            popoverOpen: true,
            popoverRouteOnOpen: {
              route: next.route,
              navigationOptions: next.navigationOptions
            }
          }
        }));
      }
    } catch (e) {
      error = true;
      logger.error(e);

      Analytics.logEvent(
        'signup-error',
        guest ? 'guest-state' : 'join-state',
        ['segmentio'],
        {
          message: extractMessageFromError(e),
          error: e
        }
      );

      ToastQueue.add({
        title: $_('error.title'),
        message: extractMessageFromError(e),
        type: 'error',
        duration: 5000
      });
    } finally {
      loading = false;
    }
  };

  export const setLoading = (value: boolean) => {
    loading = value;
  };

  $: if (
    $AppState.website.connectingAccount &&
    !loading &&
    !success &&
    !error
  ) {
    AppState.update(state => ({
      ...state,
      website: {
        ...state.website,
        connectingAccount: false
      }
    }));

    clearTimeout(timeout);
    timeout = setTimeout(() => triggerConnectCustomer(), 10);
  }
</script>

<slot {loading} />
